import React from 'react';
import { Carousel } from 'react-bootstrap';
import index_1 from '../img/carreras_gratuitas.png';
import index_2 from '../img/carreras_desarrollo.png';
import index_3 from '../img/carreras_contable.png';
import index_4 from '../img/carreras_bromatologia.png';
import index_5 from '../img/carreras_energias.png';
import imagenesCarreras from '../data/imagenesCarreras';

const imagenes = [
  { src: index_1, alt: 'Carreras gratuitas' },
  { src: index_2, alt: 'Carrera de desarrollo de software' },
  { src: index_3, alt: 'Carrera contable' },
  { src: index_4, alt: 'Carrera de bromatología' },
  { src: index_5, alt: 'Carrera de energías renovables' },
  { src: imagenesCarreras.carrera_desarrollo_ia, alt: 'Carrera de desarrollo con inteligencia artificial' },
  { src: imagenesCarreras.carrera_gestion_digital, alt: 'Carrera de gestión digital' },
  { src: imagenesCarreras.carrera_acompanante_terapeutico, alt: 'Carrera de acompañante terapéutico' },
  { src: imagenesCarreras.carrera_turismo, alt: 'Carrera de turismo' },
];

const Carrousel = () => {
  return (
    <Carousel controls={false}>
      {imagenes.map(({ src, alt }) => (
        <Carousel.Item key={src}>
          <img
            className="d-block w-100"
            src={src}
            alt={alt}
          />
          <Carousel.Caption>
            <p>.</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default Carrousel
